import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { App } from './App';
import { queryClient } from './lib/query-client';
import { ThemeProvider } from './components/theme-provider';

// Deploy nuevo con la pestaña abierta: un chunk lazy viejo ya no existe y el
// import dinámico falla. Vite avisa con `vite:preloadError`: se recarga UNA vez
// (marca en sessionStorage) para traer el bundle nuevo (review del fix de T3b).
window.addEventListener('vite:preloadError', () => {
  try {
    if (sessionStorage.getItem('redeapp.recargaPorChunk')) return;
    sessionStorage.setItem('redeapp.recargaPorChunk', '1');
  } catch {
    return;
  }
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
